import { useTheme } from "@emotion/react";
import { yupResolver } from "@hookform/resolvers/yup";
import { Grid } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { auth } from "src/apis";
import { login } from "src/store/authReducer";
import { storeMenu } from "src/store/menuReducer";
import Intro from "./Components/Intro";
import LoginBox from "./Components/LoginBox";
import loginResolver from "./Components/loginResolver";
import { handleRoleSelection, setCreds, setRoles } from "store/roleReducer";

// ==============================|| WRAPPER ||============================== //

const GovLogin = () => {
  const dispatch = useDispatch();
  const loginForm = useForm({ resolver: yupResolver(loginResolver) });

  const navigate = useNavigate();
  const handleLogin = async (data) => {
    console.log(data)
    await auth
      .selectFunction({
        username: data?.email,
        password: data?.password,
      })
      .then((res) => {

        console.log(res)
        if (res?.data?.status === 'select_urpfId') {
          dispatch(setCreds({
            creds: {
              username: data.email,
              password: data.password
            }
          }));
          dispatch(setRoles({ roles: res?.data?.data }));
          dispatch(handleRoleSelection(true));
        }
        else {
          dispatch(
            login({
              token: res?.token,
              refreshToken: res?.refreshToken,
              user: res?.user,
              seasonId: res?.season,
            })
          );
          dispatch(setRoles({ roles: [] }))
          dispatch(storeMenu(res?.menu));
          navigate("/home");
        }
      })

      .catch((err) => {
        console.log(err);
        enqueueSnackbar("Ανεπιτυχής προσπάθεια σύνδεσης.", {
          variant: "error",
        });
      });
  };

  const theme = useTheme();

  return (
    <Grid
      container
      py={2}
      px={4}
      sx={{
        minHeight: "76vh",
        justifyContent: "center",
        alignItems: "flex-start",
      }}
    >
      <Grid container item xs={12} justifyContent={"center"} spacing={2}>
        <Grid item xs={12} sm={9} md={7} lg={8} mb={4}>
          <h1 align="center">
            Παροχή Χρηματικού Βοηθήματος σε Δικαιούχους (ΛΑΕ/ΟΠΕΚΑ)
          </h1>
        </Grid>

        <Grid item sm={10} md={7} lg={8}>
          <Intro />
        </Grid>
        <Grid
          container
          item
          sm={10}
          md={4}
          lg={3}
          sx={{ justifyContent: "center" }}
        >
          <LoginBox
            loginForm={loginForm}
            handleLogin={loginForm.handleSubmit(handleLogin)}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default GovLogin;
